import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Stack,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../components/MaterialTypography";
import MaterialSelect from "../components/MasterSelect";
import styles from "../components/MasterSelect/styles";
import Select from "@mui/material/Select";
import { BsFillPersonVcardFill } from "react-icons/bs";
import { FaPeopleGroup } from "react-icons/fa6";
import MaterialBox from "../components/MaterialBox";
import MaterialInput from "../components/MaterialInput";
import colors from "../assest/theme/base/colors";
import BASEURL from "../pages/Utils/Baseurl";
import * as React from "react";
import ConfirmationDialog from "../components/Dialog/ConfirmationDialog";
import { useState } from "react";
import MaterialButton from "../components/MaterialButton";
import Swal from "sweetalert2";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useUserDetails } from "../context/auth";
import { useNavigate } from "react-router-dom";
import { NumericFormat } from "react-number-format";

const Newstaff = () => {
  const data = sessionStorage.getItem("user");
  const parsedData = JSON.parse(data);

  const { AccessData } = useUserDetails();
  const navigate = useNavigate();

  const jobstatus = [
    { value: "Open", label: "Open" },
    { value: "Closed", label: "Closed" },
    { value: "Hold", label: "Hold" },
  ];
  const employeeTypes = [
    { value: "Employee", label: "Employee" },
    { value: "Intern", label: "Intern" },
  ];
  const priority = [
    { value: "High", label: "High" },
    { value: "Medium", label: "Medium" },
    { value: "Low", label: "Low" },
  ];

  const [staffrequest, setstaffrequest] = useState({
    jobid: "",
    requestdate: new Date().toISOString().split("T")[0],
    teamname: { value: parsedData?.department, label: parsedData?.department },
    teamleadname: {
      value: parsedData?.first_name,
      label: parsedData?.first_name,
    },
    projectname: "",
    startdate: new Date().toISOString().split("T")[0],
    role: "",
    salarylpa: "",
    experience: "",
    employmentType: "",
    keySkills: "",
    priority: "",
    Noofposition: "",
    preference: "",
    interviewpannel: "",
    Noofrounds: "",
    responsiableperson: "",
    position: "",
    jd: "",
    justificationrequest: "",
    jobstatusvalue: "",

    jobidStatus: "",
    jobstatusvalueStatus: "",
    requestdateStatus: "",
    teamnameStatus: "",
    teamleadnameStatus: "",
    projectnameStatus: "",
    startdateStatus: "",
    roleStatus: "",
    salarylpaStatus: "",
    experienceStatus: "",
    employmentTypeStatus: "",
    keySkillsStatus: "",
    priorityStatus: "",
    NoofpositionStatus: "",
    preferenceStatus: "",
    interviewpannelStatus: "",
    NoofroundsStatus: "",
    responsiablepersonStatus: "",
    positionStatus: "",
    jdStatus: "",
    justificationrequestStatus: "",
  });


  const [originalleaveconfigdata, setoriginalleaveconfigdata] = useState({
    jobid: "",
    requestdate: "",
    teamname: "",
    teamleadname: "",
    projectname: "",
    startdate: "",
    role: "",
    salarylpa: "",
    experience: "",
    employmentType: "",
    keySkills: "",
    priority: "",
    Noofposition: "",
    preference: "",
    interviewpannel: "",
    Noofrounds: "",
    responsiableperson: "",
    position: "",
    jd: "",
    justificationrequest: "",
    jobstatusvalue: "",

    jobidStatus: "",
    jobstatusvalueStatus: "",
    requestdateStatus: "",
    teamnameStatus: "",
    teamleadnameStatus: "",
    projectnameStatus: "",
    startdateStatus: "",
    roleStatus: "",
    salarylpaStatus: "",
    experienceStatus: "",
    employmentTypeStatus: "",
    keySkillsStatus: "",
    priorityStatus: "",
    NoofpositionStatus: "",
    preferenceStatus: "",
    interviewpannelStatus: "",
    NoofroundsStatus: "",
    responsiablepersonStatus: "",
    positionStatus: "",
    jdStatus: "",
    justificationrequestStatus: "",
  });
  const [allemployee, setallemployee] = useState({
    userName: [],
  });
  const [allDepartment, setallDepartment] = useState({
    departmentnames: [],
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [department, setdepartment] = useState([]);
  const [employeenames, setemployeenames] = useState([]);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [id, setId] = useState(null);

  React.useEffect(() => {
    getemployee();
    onDepartmentSubmit();
    generateJobId();
  }, []);

  const getemployee = async () => {
    const query = `query{
      allUsersDetail{
              id
            firstName
              empid
           email
             }
            }`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const managerListdata = response.data.data.allUsersDetail;
      setemployeenames(managerListdata);
      setallemployee({
        ...allemployee,
        userName: managerListdata,
      });
    } catch (error) {}
  };

  const onDepartmentSubmit = async () => {
    const query = `query {
        allDepartment {
            id
            departmentName
            departmentCode
        }
    }`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const departmentList = response.data.data.allDepartment;
      setdepartment(departmentList);
      setallDepartment({
        ...allDepartment,
        departmentnames: departmentList,
      });
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const [jobId, setJobId] = useState("");

  const generateJobId = () => {
    const prefix = "JOB"; // Prefix for Job ID
    const uniqueId = Date.now(); // Use timestamp as a unique identifier
    const randomSuffix = Math.floor(1000 + Math.random() * 9000); // 4-digit random number
    const newJobId = `${prefix}${randomSuffix}`;
    setJobId(newJobId);
  };


  React.useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      // setPageState((prevState) => ({
      //   ...prevState,
      //   loading: false,
      //   state: "default",
      // }));
    }
  }, [department, employeenames]);

  const [Statusfield, setStatusfield] = useState(false);

  const formatIndianNumber = (num) => {
    let x = num.replace(/,/g, ""); // Remove existing commas
    let lastThree = x.slice(-3);
    let otherNumbers = x.slice(0, -3);
    if (otherNumbers !== "") {
      lastThree = "," + lastThree;
    }
    return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  };
  const formatIndianNumber1 = (num) => {
    if (!num) return ""; // Handle empty values gracefully
  
    let x = num.toString().replace(/,/g, ""); // Ensure it's a string and remove existing commas
    let lastThree = x.slice(-3);
    let otherNumbers = x.slice(0, -3);
  
    if (otherNumbers !== "") {
      lastThree = "," + lastThree;
    }
    
    return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  };
  
  const getInitData = async (id) => {
    const query = `query GetStaffRequestById($id: ID!) {
  staffRequest(id: $id) {
    jobid
    requestDate
    teamName
    teamLeadName
    projectName
    startDate
    role
    salaryLpa
    experience
    employmentType
    approvalStatus
    jobStatus
    keySkills
    priority
    noOfPositions
    preference
    interviewPannel
    noOfRounds
    responsiblePerson
    positionStatus
    jd
    justificationForRequest
  }
} `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data.staffRequest;
      let teamname = department.filter((val) => val.id === result.teamName);
      let teamlead = employeenames.filter(
        (val) => val.id === result.teamLeadName
      );


      if (result.approvalStatus == "Approved") {
        // setTogglePage({
        //   ...togglePage,
        //   edit: false,
        //   view: false,
        // });
      }
     setJobId(result.jobid)
      setstaffrequest({
        ...staffrequest,
        approvalStatus: result.approvalStatus,
        jobid: result.jobid,
        requestdate: result.requestDate,
        teamname: { value: result.teamName, label: result.teamName },
        teamleadname: {
          value: result.teamLeadName,
          label: result.teamLeadName,
        },
        projectname: result.projectName,
        startdate: result.startDate,
        role: result.role,
        salarylpa: formatIndianNumber1(result.salaryLpa),
        experience: result.experience,
        employmentType: {
          value: result.employmentType,
          label: result.employmentType,
        },
        priority: { value: result.priority, label: result.priority },
        keySkills: result.keySkills,
        Noofposition: result.noOfPositions,
        Noofrounds: result.noOfRounds,
        jd: result.jd,
        justificationrequest: result.justificationForRequest,
        jobstatusvalue: { value: result.jobStatus, label: result.jobStatus },
      });
      setoriginalleaveconfigdata({
        ...originalleaveconfigdata,
        jobid: result.jobid,
        requestdate: result.requestDate,
        teamname: { value: result.teamName, label: result.teamName },
        teamleadname: {
          value: result.teamLeadName,
          label: result.teamLeadName,
        },
        projectname: result.projectName,
        startdate: result.startDate,
        role: result.role,
        salarylpa: result.salaryLpa,
        experience: result.experience,
        employmentType: {
          value: result.employmentType,
          label: result.employmentType,
        },
        priority: { value: result.priority, label: result.priority },
        keySkills: result.keySkills,
        Noofposition: result.noOfPositions,
        Noofrounds: result.noOfRounds,
        jd: result.jd,
        justificationrequest: result.justificationForRequest,
        jobstatusvalue: { value: result.jobStatus, label: result.jobStatus },
      });
      setTogglePage({
        ...togglePage,
        view: true,
      });
      setStatusfield(true);
    } catch (error) {
      console.error("ResponseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };


  const handlestaffChange = (event, selectEvent) => {
    let sourceState = { ...staffrequest };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "teamname") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "jobstatusvalue") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "teamleadname") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      sourceState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "projectname":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,25})$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "jobid":
          {
            const alphanumericRegex = new RegExp(/^[a-zA-Z0-9]+$/);

            if (alphanumericRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "requestdate":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );
            if (dateLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "startdate":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );
            if (dateLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        sourceState[event.target.name] = event.target.value;
      }
    }
    setstaffrequest(sourceState);
  };
 

  const handlepostiondetails222 = (event) => {
    let value = event.target.value.replace(/,/g, ""); // Remove existing commas

    if (value === "") {
      // If input is cleared, reset the status and value
      setstaffrequest((prevState) => ({
        ...prevState,
        salarylpa: "",
        salarylpaStatus: "unchecked",
      }));
    } else if (/^\d{0,7}$/.test(value)) {
      // Allow only numbers up to 7 digits
      let formattedValue = formatIndianNumber(value);

      setstaffrequest((prevState) => ({
        ...prevState,
        salarylpa: formattedValue,
        salarylpaStatus: value.length >= 5 ? "success" : "error",
      }));
    }
  };

  const handlepostiondetails = (event, selectEvent) => {
    let sourceState = { ...staffrequest };
    if (event?.target === undefined && selectEvent) {
      // if (selectEvent.name === "role") {
      //   const lengthRegex = new RegExp("^[A-Za-z0-9]");
      //   if (lengthRegex.test(event?.label) === true) {
      //     sourceState[selectEvent.name + "Status"] =
      //       event?.label === undefined ? "unchecked" : "success";
      //   } else {
      //     sourceState[selectEvent.name + "Status"] =
      //       selectEvent.value === "" ? "unchecked" : "error";
      //   }
      // }
      if (selectEvent.name === "employmentType") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "keySkills") {
        const lengthRegex = new RegExp("^([a-zA-Z ]{1,250})$");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "priority") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "interviewpannel") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "responsiableperson") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "position") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      sourceState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "salarylpa":
          {
            let value = event.target.value.replace(/,/g, ""); // Remove existing commas
            const numberRegex = /^\d{0,7}$/; // Allow only numbers up to 7 digits

            if (numberRegex.test(value)) {
              sourceState[event.target.name] = formatIndianNumber(value); // Format with commas
              sourceState[event.target.name + "Status"] =
                value.length >= 5 ? "success" : "error";
            } else {
              sourceState[event.target.name + "Status"] =
                value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "experience":
          {
            const alphaNumberLengthRegex = /^\d{0,2}(\.\d{0,2})?$/;

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "Noofposition":
          {
            const numberRegex = /^[1-9]{0,1}$/; // Allows only 1-digit numbers (1-9)

            if (numberRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "success";
            } else {
              sourceState[event.target.name + "Status"] = "error";
            }
          }
          break;

        case "role":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "keySkills":
          {
            // const alphaNumberLengthRegex = new RegExp(
            //   "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~ ]{1,250}$"
            // );
            const alphaNumberLengthRegex = new RegExp("^.{1,250}$", "s");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "Noofrounds":
          {
            const numberRegex = /^[1-9]{0,1}$/; // Allows only 1-digit numbers (1-9)

            if (numberRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "success";
            } else {
              sourceState[event.target.name + "Status"] = "error";
            }
          }
          break;
        case "jd":
          {
            // const alphaNumberLengthRegex = new RegExp(
            //   "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~ ]{1,1000}$"
            // );
            const alphaNumberLengthRegex = new RegExp("^.{1,1000}$", "s");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "justificationrequest":
          {
            // const alphaNumberLengthRegex = new RegExp(
            //   "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~ ]{1,250}$"
            // );
            const alphaNumberLengthRegex = new RegExp("^.{1,250}$", "s");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        sourceState[event.target.name] = event.target.value;
      }
    }
    setstaffrequest(sourceState);
  };

  const handleAdd = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handleSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleSubmit = async () => {
    const query = `mutation CreateStaffRequest($input: StaffRequestInput!) {
  createStaffRequest(input: $input) {
    staffRequest {
      id
      jobid
      teamName
      projectName
      empid
    }
  }
}`;

    let alldata = {
      jobid: jobId,
      requestDate: staffrequest?.requestdate,
      teamName: staffrequest?.teamname?.label,
      teamLeadName: staffrequest?.teamleadname?.label,
      projectName: staffrequest?.projectname,
      startDate: staffrequest?.startdate,
      role: staffrequest?.role,
      salaryLpa: staffrequest.salarylpa.replace(/,/g, ""),
      experience: staffrequest?.experience,
      employmentType: staffrequest?.employmentType?.value,
      keySkills: staffrequest?.keySkills,
      priority: staffrequest?.priority?.value,
      noOfPositions: staffrequest?.Noofposition,
      noOfRounds: staffrequest?.Noofrounds,
      jd: staffrequest?.jd,
      justificationForRequest: staffrequest?.justificationrequest,
      jobStatus: "Open",
      empid: parsedData?.empid,
    };


    try {
      const response = await axios.post(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        query,
        variables: {
          input: alldata,
        },
      });


      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      let finaldata = response.data.data.createStaffRequest.staffRequest;

      if (finaldata !== "") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Staff Request Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/staff-request");
      }
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      // staffrequest.jobidStatus === "success" &&
      // staffrequest.requestdateStatus === "success" &&
      // staffrequest.teamnameStatus === "success" &&
      // staffrequest.teamleadnameStatus === "success" &&
      staffrequest.projectnameStatus === "success" &&
      // staffrequest.startdateStatus === "success" &&
      staffrequest.roleStatus === "success" &&
      staffrequest.salarylpaStatus === "success" &&
      staffrequest.experienceStatus === "success" &&
      staffrequest.employmentTypeStatus === "success" &&
      staffrequest.keySkillsStatus === "success" &&
      staffrequest.priorityStatus === "success" &&
      staffrequest.NoofpositionStatus === "success" &&
      staffrequest.NoofroundsStatus === "success" &&
      staffrequest.jdStatus === "success" &&
      staffrequest.justificationrequestStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleEdit = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to Update your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        Updatestaffrequest();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const Updatestaffrequest = async () => {
    const query = `
    mutation UpdateStaffRequest($id: ID!, $input: StaffRequestInput!) {
      updateStaffRequest(id: $id, input: $input) {
        staffRequest {
          jobid
          requestDate
          teamName
          teamLeadName
          projectName
          startDate
          role
          salaryLpa
          experience
          employmentType
          approvalStatus
          jobStatus
          keySkills
          priority
          noOfPositions
          preference
          interviewPannel
          noOfRounds
          responsiblePerson
          positionStatus
          jd
          justificationForRequest
        }
      }
    }
  `;

    // Ensure staffrequest object is correctly populated
    let alldata = {
      jobid: staffrequest.jobid?.value,
      requestDate: staffrequest?.requestdate,
      teamName: staffrequest?.teamname?.value,
      teamLeadName: staffrequest?.teamleadname?.label,
      projectName: staffrequest?.projectname,
      startDate: staffrequest?.startdate,
      role: staffrequest?.role,
      salaryLpa: staffrequest.salarylpa.replace(/,/g, ""),
      experience: staffrequest?.experience,
      employmentType: staffrequest?.employmentType?.value,
      keySkills: staffrequest?.keySkills,
      priority: staffrequest?.priority?.value,
      noOfPositions: staffrequest?.Noofposition,
      noOfRounds: staffrequest?.Noofrounds,
      jd: staffrequest?.jd,
      justificationForRequest: staffrequest?.justificationrequest,
      jobStatus: staffrequest.jobstatusvalue?.value,
    };

    try {
      const response = await axios.post(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        query,
        variables: {
          id: id,
          input: alldata,
        },
      });


      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      let finaldata = response.data.data.updateStaffRequest.staffRequest;

      if (finaldata !== "") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Staff Request Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/staff-request");
      }
    } catch (error) {
      // Handle network or unexpected errors
      console.error("Network or unexpected error:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for the inconvenience, there is an issue with our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteStaff();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteStaff = async () => {
    const query = `
        mutation($id: ID!) { 
 deleteStaffRequest(id: $id) {
    success
    message
}
}
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      const responseData = response.data;


      // Ensure that the success flag is checked correctly
      if (responseData.data.deleteStaffRequest.success) {
        navigate("/staff-request");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Staff Request Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
      }
    } catch (error) {
      console.error("An error occurred while deleting the wfh:", error);
    }
  };

  const handleDiscard = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to discard your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDiscardWfh();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDiscardWfh = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setstaffrequest({
      jobid: originalleaveconfigdata.jobid,
      requestdate: originalleaveconfigdata.requestdate,
      teamname: originalleaveconfigdata.teamname,
      projectname: originalleaveconfigdata?.projectname,
      teamleadname: originalleaveconfigdata.teamleadname,
      startdate: originalleaveconfigdata?.startdate,
      role: originalleaveconfigdata.role,
      salarylpa: originalleaveconfigdata?.salarylpa,
      experience: originalleaveconfigdata?.experience,
      employmentType: originalleaveconfigdata.employmentType,
      keySkills: originalleaveconfigdata?.keySkills,
      priority: originalleaveconfigdata.priority,
      Noofposition: originalleaveconfigdata?.Noofposition,
      Noofrounds: originalleaveconfigdata?.Noofrounds,
      jd: originalleaveconfigdata.jd,
      justificationrequest: originalleaveconfigdata.justificationrequest,
      jobstatusvalue: originalleaveconfigdata.jobstatusvalue,
    });
    setConfirmationDialog({
      ...confirmationDialog,
      open: false,
    });
  };

  const handlecancel = () => {
    navigate("/staff-request");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true || togglePage.edit === true ? (
                // <Stack
                //   direction="row"
                //   justifyContent="space-between"
                //   alignItems="center"
                //   spacing={2}
                // >
                //   <Stack direction="column" spacing={0}>
                //     <MaterialTypography variant="h5" fontWeight="medium">
                //       Edit Staff Request
                //     </MaterialTypography>
                //   </Stack>

                //   {AccessData &&
                //     Array.isArray(AccessData) &&
                //     AccessData.some(
                //       (item) =>
                //         item.component === "EditStaff" && item.can_access
                //     ) &&
                //     pageState.state !== "submitting" &&
                //     (staffrequest.approvalStatus === null ||
                //       staffrequest.approvalStatus !== "Approved") && ( // Show when null, hide only if Approved
                //       <ButtonGroup
                //         variant="outlined"
                //         aria-label="Loading button group"
                //       >
                //         <MaterialButton
                //           variant="gradient"
                //           color="dark"
                //           onClick={toggleEdit}
                //           startIcon={<EditIcon />}
                //         >
                //           Edit
                //         </MaterialButton>
                //         <MaterialButton
                //           variant="gradient"
                //           color="dark"
                //           onClick={AddDelete}
                //           startIcon={<DeleteIcon />}
                //         >
                //           Delete
                //         </MaterialButton>
                //       </ButtonGroup>
                //     )}
                // </Stack>
                <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Staff Request Details
                  </MaterialTypography>
                </Stack>

                {AccessData &&
                  Array.isArray(AccessData) &&
                  AccessData.some(
                    (item) =>
                      item.component === "EditStaff" && item.can_access
                  ) &&
                  pageState.state !== "submitting" &&
                  ( // Show when null, hide only if Approved
                    <ButtonGroup
                      variant="outlined"
                      aria-label="Loading button group"
                    >
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={toggleEdit}
                        startIcon={<EditIcon />}
                      >
                        Edit
                      </MaterialButton>
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={AddDelete}
                        startIcon={<DeleteIcon />}
                      >
                        Delete
                      </MaterialButton>
                    </ButtonGroup>
                  )}
              </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Add Staff Request
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent>
          <Stack direction="row" spacing={1}>
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Basic Details
            </MaterialTypography>
          </Stack>

          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Job ID <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                {/* <MaterialSelect
                  name="jobid"
                  value={staffrequest.jobid}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handlestaffChange}
                  options={jobidlist.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={staffrequest.jobidStatus === "error" ? true : false}
                  success={
                    staffrequest.jobidStatus === "success" ? true : false
                  }
                 
                /> */}
                <MaterialInput
                  name="jobid"
                  value={jobId}
                  // onChange={handlestaffChange}
                  disabled={true}
                  customStyles={{ optionPadding: 20 }}
                  error={staffrequest.jobidStatus === "error" ? true : false}
                  success={
                    staffrequest.jobidStatus === "success" ? true : false
                  }
                  //   isDisabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {staffrequest.jobidStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Job ID is Mandatory</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Requested Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="requestdate"
                  // type="date"
                  readOnly
                  value={new Date().toISOString().slice(0, 10)}
                  onChange={handlestaffChange}
                  customStyles={{ optionPadding: 20 }}
                  error={
                    staffrequest.requestdateStatus === "error" ? true : false
                  }
                  success={
                    staffrequest.requestdateStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {staffrequest.requestdateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Requested Date is Mandatory</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Team Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="teamname"
                  value={staffrequest.teamname}
                  onChange={handlestaffChange}
                  customStyles={{ optionPadding: 20 }}
                  // options={allDepartment?.departmentnames?.map((value) => {
                  //   return {
                  //     value: value.id,
                  //     label: value.departmentName,
                  //   };
                  // })}
                  error={staffrequest.teamnameStatus === "error" ? true : false}
                  success={
                    staffrequest.teamnameStatus === "success" ? true : false
                  }
                  isDisabled={true}
                  //   isClearable
                />
                {staffrequest.teamnameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Team Name is Mandatory</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Team Lead Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="teamleadname"
                  value={staffrequest.teamleadname}
                  onChange={handlestaffChange}
                  options={allemployee?.userName?.map((value) => {
                    return {
                      value: value.id,
                      label: value.firstName.toUpperCase(),
                    };
                  })}
                  customStyles={{ optionPadding: 20 }}
                  error={
                    staffrequest.teamleadnameStatus === "error" ? true : false
                  }
                  success={
                    staffrequest.teamleadnameStatus === "success" ? true : false
                  }
                  // isDisabled={togglePage.view === true ? true : false}
                  isDisabled={true}
                  //   isClearable
                />
                {staffrequest.teamleadnameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Team Lead Name is Mandatory</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Project Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="projectname"
                  value={staffrequest.projectname}
                  onChange={handlestaffChange}
                  customStyles={{ optionPadding: 20 }}
                  error={
                    staffrequest.projectnameStatus === "error" ? true : false
                  }
                  success={
                    staffrequest.projectnameStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {staffrequest.projectnameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      {" "}
                      Project Name should be a minimum of 25 characters long and
                      can contain only alphabets.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Start Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="startdate"
                  type="date"
                  value={
                    staffrequest.startdate ||
                    new Date().toISOString().split("T")[0]
                  } // Default to today
                  onChange={handlestaffChange}
                  customStyles={{ optionPadding: 20 }}
                  error={staffrequest.startdateStatus === "error"}
                  success={staffrequest.startdateStatus === "success"}
                  inputProps={{
                    min: new Date(new Date().setDate(new Date().getDate() - 7))
                      .toISOString()
                      .split("T")[0], // 7 days before today
                    max: new Date(new Date().setDate(new Date().getDate() + 7))
                      .toISOString()
                      .split("T")[0], // 7 days after today
                  }}
                  disabled={togglePage.view}
                />
                {staffrequest.startdateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Start Date is Mandatory</FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>

          <Divider />

          <Stack direction="row" spacing={1}>
            <FaPeopleGroup style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Position Details
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Role <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                {/* <MaterialSelect
                  name="role"
                  value={staffrequest.role}
                  onChange={handlepostiondetails}
                  options={jobidlist.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  customStyles={{ optionPadding: 20 }}
                  error={staffrequest.roleStatus === "error" ? true : false}
                  success={staffrequest.roleStatus === "success" ? true : false}
                
                /> */}
                <MaterialInput
                  name="role"
                  value={staffrequest.role}
                  onChange={handlepostiondetails}
                  customStyles={{ optionPadding: 20 }}
                  error={staffrequest.roleStatus === "error" ? true : false}
                  success={staffrequest.roleStatus === "success" ? true : false}
                  disabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {staffrequest.roleStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Role can contain only alphabets.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Salary LPA <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="salarylpa"
                  value={staffrequest.salarylpa}
                  onChange={handlepostiondetails222}
                  customStyles={{ optionPadding: 20 }}
                  error={staffrequest.salarylpaStatus === "error"}
                  success={staffrequest.salarylpaStatus === "success"}
                  disabled={togglePage.view === true}
                />
                {staffrequest.salarylpaStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Enter a valid Salary (5 to 7 digits)
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Experience <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="experience"
                  value={staffrequest.experience}
                  onChange={handlepostiondetails}
                  customStyles={{ optionPadding: 20 }}
                  error={
                    staffrequest.experienceStatus === "error" ? true : false
                  }
                  success={
                    staffrequest.experienceStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {staffrequest.experienceStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Should accept only numbers maximum 2 digits
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Employee Type <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="employmentType"
                  value={staffrequest.employmentType}
                  onChange={handlepostiondetails}
                  options={employeeTypes.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  customStyles={{ optionPadding: 20 }}
                  error={
                    staffrequest.employmentTypeStatus === "error" ? true : false
                  }
                  success={
                    staffrequest.employmentTypeStatus === "success"
                      ? true
                      : false
                  }
                  isDisabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {staffrequest.employmentTypeStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>EmploymentType is Mandatory</FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Priority <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="priority"
                  value={staffrequest.priority}
                  onChange={handlepostiondetails}
                  options={priority.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  customStyles={{ optionPadding: 20 }}
                  error={staffrequest.priorityStatus === "error" ? true : false}
                  success={
                    staffrequest.priorityStatus === "success" ? true : false
                  }
                  isDisabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {staffrequest.priorityStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Priority is Mandatory</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Key Skills <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="keySkills"
                  multiline
                  rows={4}
                  value={staffrequest.keySkills}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handlepostiondetails}
                  error={
                    staffrequest.keySkillsStatus === "error" ? true : false
                  }
                  success={
                    staffrequest.keySkillsStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                  //   isClearable
                />

                {staffrequest.keySkillsStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      {" "}
                      Skills should be a maximum of 250 characters long and can
                      contain only alphabets.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    No of Position <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="Noofposition"
                  // type="number"
                  value={staffrequest.Noofposition}
                  onChange={handlepostiondetails}
                  customStyles={{ optionPadding: 20 }}
                  error={
                    staffrequest.NoofpositionStatus === "error" ? true : false
                  }
                  success={
                    staffrequest.NoofpositionStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {staffrequest.NoofpositionStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      {" "}
                      No of Position Should accept numbers maximum 1 digit
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                 No of Interview Rounds <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="Noofrounds"
                  // type="number"
                  value={staffrequest.Noofrounds}
                  onChange={handlepostiondetails}
                  customStyles={{ optionPadding: 20 }}
                  error={
                    staffrequest.NoofroundsStatus === "error" ? true : false
                  }
                  success={
                    staffrequest.NoofroundsStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {staffrequest.NoofroundsStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      No of Rounds Should accept numbers maximum 1 digit
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              {Statusfield && (
                <Grid size={{ xs: 5, sm: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Job Status
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="jobstatusvalue"
                    value={staffrequest.jobstatusvalue}
                    onChange={handlestaffChange}
                    customStyles={{ optionPadding: 20 }}
                    options={jobstatus?.map((value) => {
                      return {
                        value: value.value,
                        label: value.value,
                      };
                    })}
                    error={
                      staffrequest.jobstatusvalueStatus === "error"
                        ? true
                        : false
                    }
                    success={
                      staffrequest.jobstatusvalueStatus === "success"
                        ? true
                        : false
                    }
                    isDisabled={togglePage.view === true ? true : false}
                    //   isClearable
                  />
                  {staffrequest.jobstatusvalueStatus === "error" && (
                    <FormControl error>
                      {/* <FormHelperText>Team Name is Mandatory</FormHelperText> */}
                    </FormControl>
                  )}
                </Grid>
              )}

              <Grid size={{ xs: 5, sm: 5 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    JD <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="jd"
                  multiline
                  rows={5}
                  value={staffrequest.jd}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handlepostiondetails}
                  error={staffrequest.jdStatus === "error" ? true : false}
                  success={staffrequest.jdStatus === "success" ? true : false}
                  disabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {staffrequest.jdStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      JD Should accept maximum 1000 characters.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 5 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Justification for Request{" "}
                    <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="justificationrequest"
                  multiline
                  rows={5}
                  value={staffrequest.justificationrequest}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handlepostiondetails}
                  error={
                    staffrequest.justificationrequestStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    staffrequest.justificationrequestStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {staffrequest.justificationrequestStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Justification request Should accept maximum 250
                      characters.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            {/* Left side: Close button (Only visible when editing or viewing) */}
            {(togglePage.edit === true || togglePage.view === true) && (
              <MaterialButton
                variant="gradient"
                color="dark"
                sx={{ m: 2 }}
                onClick={handlecancel} // Close button (left side)
              >
                Close
              </MaterialButton>
            )}

            {/* Right side: Buttons */}
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
              flexGrow={1}
            >
              {togglePage.edit === true ? (
                <>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    disabled={pageState.state === "submitting"}
                    onClick={handleDiscard}
                  >
                    Discard
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={pageState.state === "submitting"}
                    onClick={handleEdit}
                  >
                    Update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
                <>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={handlecancel} // Cancel button (right side)
                  >
                    Cancel
                  </MaterialButton>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleAdd}
                  >
                    Submit
                  </MaterialButton>
                </>
              ) : null}
            </MaterialBox>
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default Newstaff;
